module.exports = __webpack_public_path__ + "img/garant-img-8.ff1ca697.png";